// extracted by mini-css-extract-plugin
module.exports = {"root":"MoonChainSection_root__xv0Di","chainPaper":"MoonChainSection_chainPaper__timvl"};